type StorageReader = Pick<Storage, 'getItem' | 'setItem'>;

export const LastLoginAuthTypeStorageKey = 'LastLoginAuthType';

const getLocalStorage = (): StorageReader | undefined => {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
};

export const getStoredLastLoginAuthType = (): string | null => {
  try {
    return getLocalStorage()?.getItem(LastLoginAuthTypeStorageKey) ?? null;
  } catch {
    return null;
  }
};

export const storeLastLoginAuthType = (authType: string): void => {
  try {
    getLocalStorage()?.setItem(LastLoginAuthTypeStorageKey, authType);
  } catch {
    // Storage can be unavailable when browser privacy settings block access.
  }
};
